import { styled } from 'goober';

export const WorkspaceSwitchContainer = styled('div')(() => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    gap: '8px',
    marginTop: '24px',
    width: '100%',
    maxWidth: '260px',
    maxHeight: '40vh',
    overflowY: 'auto',
}));
